{
  "codexEntityForm": {
    "character": "Personnage",
    "place": "Lieu",
    "faction": "Faction",
    "object": "Objet",
    "concept": "Concept",
    "editName": "Modifier {{name}}",
    "newCodexEntry": "Nouvelle entrée du Codex",
    "theWorldHasChangedTheDraft": "Le monde a changé. Le brouillon est conservé ; rechargez l'entrée avant d'enregistrer.",
    "portraitChooseAnImage": "Portrait : choisir une image",
    "change": "Changer",
    "addPortrait": "Ajouter un portrait",
    "portraitImage": "Image du portrait",
    "entryName": "Nom de l'entrée",
    "name": "Nom",
    "entryType": "Type d'entrée",
    "customCategory": "Catégorie personnalisée",
    "categoryEGDeityShipSpell": "Catégorie, par ex. Divinité, Navire, Sort",
    "aliases": "Alias",
    "entryAliases": "Alias de l'entrée",
    "otherNamesOneAtATime": "Autres noms, un à la fois…",
    "tags": "Étiquettes",
    "entryTags": "Étiquettes de l'entrée",
    "themesRolesArcs": "Thèmes, rôles, arcs…",
    "collection": "Collection",
    "entryCollection": "Collection de l'entrée",
    "noCustomCollection": "Aucune collection personnalisée",
    "folder": "Dossier",
    "entryFolder": "Dossier de l'entrée",
    "unfiled": "Non classée",
    "notes": "Notes",
    "entryNotes": "Notes de l'entrée",
    "whoTheyAreWhatTheyWant": "Qui est la personne, ce qu'elle veut, ce que le lecteur ne doit jamais apprendre trop tôt…",
    "entryFields": "Champs de l'entrée",
    "fields": "Champs",
    "fieldTemplate": "Modèle de champs",
    "template": "Modèle…",
    "schemaOf": "Schéma de",
    "addMissingFields": "Ajouter les champs manquants",
    "addField": "Ajouter un champ",
    "noCustomFieldYetFieldsGive": "Aucun champ personnalisé pour l'instant. Les champs donnent à une entrée des faits structurés — âge, allégeance, secret — que les Vérifications peuvent exploiter.",
    "sharedFieldNamesTypesAndOptions": "Les noms, types et options des champs partagés se gèrent dans les réglages de la collection. Les valeurs appartiennent à cette page.",
    "fieldNameN": "Nom du champ {{n}}",
    "fieldName": "Nom du champ",
    "fieldTypeN": "Type du champ {{n}}",
    "unknown": "Inconnu",
    "fieldValueN": "Valeur du champ {{n}}",
    "select": "Sélectionner…",
    "yes": "Oui",
    "no": "Non",
    "value": "Valeur",
    "chooseAnEntry": "Choisir une entrée…",
    "eGSpringOfYear12": "par ex. Printemps de l'an 12, ou le jour du siège",
    "below": "Sous",
    "unknownValueN": "Valeur inconnue {{n}}",
    "required": "Obligatoire",
    "sharedField": "Champ partagé",
    "remove": "Retirer",
    "confirmRemoval": "Confirmer le retrait",
    "paragraph": "Paragraphe",
    "aFewLines": "Quelques lignes…",
    "discardTheDraft": "Abandonner le brouillon ?",
    "confirmReload": "Confirmer le rechargement",
    "keepEditing": "Continuer à modifier",
    "reloadEntry": "Recharger l'entrée",
    "cancel": "Annuler",
    "chooseAnImageFileForThe": "Choisissez un fichier image pour le portrait.",
    "thePortraitMustBeUnder8": "Le portrait doit faire moins de 8 Mio.",
    "saveEntry": "Enregistrer l'entrée",
    "searchEntries": "Rechercher des entrées…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Nouvelle entrée du Codex",
    "savedToWorldCodexTheManuscript": "Enregistrée dans Monde › Codex ; le manuscrit la mentionnera là où vous écriviez.",
    "createAndMention": "Créer et mentionner"
  },
  "continuityPanel": {
    "relationsOverTime": "Relations dans le temps",
    "checkingRelations": "Vérification des relations…",
    "cancel": "Annuler",
    "theProjectHasChangedRunThe": "Le manuscrit ou le monde a changé depuis cette exécution. Relancez les vérifications pour actualiser les relations.",
    "anAnalysisLimitWasReachedThe": "Une limite d'analyse a été atteinte. Le résultat est partiel.",
    "ruleApplied": "Règle : « {{label}} », {{rule}}.",
    "oneSourcePerTarget": "une source pour chaque cible",
    "oneTargetPerSource": "une cible pour chaque source",
    "interval": "de {{start}} à {{end}}",
    "openScene": "Ouvrir {{scene}}",
    "findingReferenceMissing": "Renvoie à une entrée qui n'existe plus.",
    "findingConfirmedWithoutEvidence": "Confirmée sans citation du texte, sa source ne peut donc pas être vérifiée.",
    "findingEvidenceMissing": "Une citation sur laquelle elle s'appuie a disparu.",
    "findingEvidenceNotCurrent": "Une citation sur laquelle elle s'appuie n'est pas confirmée ou ne correspond plus au texte.",
    "findingExclusiveNotEvaluable": "Impossible à vérifier avec la règle : il faut une direction, les deux extrémités et une période complète.",
    "findingExclusiveOverlap": "Deux de ces relations sont vraies en même temps, ce que la règle n'autorise pas.",
    "findingOther": "Quelque chose à vérifier dans cette relation.",
    "theProjectExceedsTheLimitOf": "Le projet dépasse la limite de cette analyse. Aucune donnée n'a été modifiée.",
    "theAnalysisExceededItsExecutionLimit": "L'analyse a dépassé sa limite d'exécution. Aucune donnée n'a été modifiée.",
    "analysisCancelled": "Analyse annulée.",
    "checksNotCompletedTheTextAnd": "Vérifications non terminées. Le texte et le canon n'ont pas été modifiés."
  },
  "eventTimelinePanel": {
    "eventHistory": "Historique des événements",
    "timeline": "Chronologie",
    "newEvent": "Nouvel événement",
    "searchEvents": "Rechercher des événements",
    "searchEvents2": "Rechercher des événements…",
    "timelineOrder": "Ordre de la chronologie",
    "storyTime": "Temps de l'histoire",
    "readingOrder": "Ordre de lecture",
    "dateStatus": "État des dates",
    "allDates": "Toutes les dates",
    "resolvedDates": "Dates résolues",
    "unresolvedDates": "Dates non résolues",
    "filterEventsByScene": "Filtrer les événements par scène",
    "allScenes": "Toutes les scènes",
    "scenes": "Scènes",
    "editEvent": "Modifier l'événement",
    "closeEventEditor": "Fermer l'éditeur d'événement",
    "theWorldHasChangedReloadThe": "Le monde a changé. Rechargez l'événement avant d'enregistrer ; les champs du brouillon sont conservés.",
    "eventTitle": "Titre de l'événement",
    "whatHappens": "Ce qui se passe",
    "scene": "Scène",
    "eventScene": "Scène de l'événement",
    "notLinked": "Non lié",
    "removedSceneSceneid": "Scène supprimée — {{sceneId}}",
    "dateType": "Type de date",
    "eventDateType": "Type de date de l'événement",
    "unknown": "Inconnue",
    "definedInterval": "Intervalle défini",
    "relativeToAnEvent": "Relative à un événement",
    "start": "Début",
    "eventStart": "Début de l'événement",
    "endExclusive": "Fin (exclue)",
    "eventEnd": "Fin de l'événement",
    "referenceEvent": "Événement de référence",
    "select": "Sélectionner…",
    "referenceToVerifyAnchoreventid": "Référence à vérifier — {{anchorEventId}}",
    "events": "Événements",
    "offsetInTicks": "Décalage en ticks",
    "eventOffset": "Décalage de l'événement",
    "saveEvent": "Enregistrer l'événement",
    "closeReload": "Fermer / recharger…",
    "discardTheDraftChanges": "Abandonner les modifications du brouillon ?",
    "discardDraft": "Abandonner le brouillon",
    "reloadEvent": "Recharger l'événement",
    "keepEditing": "Continuer à modifier",
    "noEventMatchesTheseFiltersEvents": "Aucun événement ne correspond à ces filtres. Les événements sont ce sur quoi s'appuient les Vérifications : quand quelque chose s'est produit, et dans quelle scène le lecteur l'apprend.",
    "tickStart": "Tick {{start}}",
    "openScene": "Ouvrir la scène",
    "editTitle": "Modifier {{title}}",
    "removeTitle": "Supprimer {{title}}",
    "confirmEventRemoval": "Confirmer la suppression de l'événement",
    "cancel": "Annuler",
    "theWorldHasChangedCancelAnd": "Le monde a changé : annulez et rouvrez la confirmation.",
    "resolvedDate": "Date résolue",
    "unknownDate": "Date inconnue",
    "missingReference": "Référence manquante",
    "timeCycle": "Cycle temporel",
    "dateOutOfRange": "Date hors plage",
    "eventsFoundOfTotal_one": "{{count}} événement trouvé · {{total}} au total",
    "eventsFoundOfTotal_many": "{{count}} événements trouvés · {{total}} au total",
    "eventsFoundOfTotal_other": "{{count}} événements trouvés · {{total}} au total",
    "removeThisEventReferences_one": "Supprimer cet événement ? {{count}} référence directe devra être revue.",
    "removeThisEventReferences_many": "Supprimer cet événement ? {{count}} références directes devront être revues.",
    "removeThisEventReferences_other": "Supprimer cet événement ? {{count}} références directes devront être revues.",
    "showMoreEvents_one": "Afficher {{count}} événement de plus",
    "showMoreEvents_many": "Afficher {{count}} événements de plus",
    "showMoreEvents_other": "Afficher {{count}} événements de plus"
  },
  "fieldEditor": {
    "choose": "Choisir…",
    "labelSearch": "Recherche : {{label}}",
    "search": "Rechercher…",
    "labelOptions": "Options : {{label}}",
    "noMatch": "Aucun résultat.",
    "optionsOnePerLine": "Options, une par ligne",
    "fieldOptionsIndex": "Options du champ {{index}}",
    "addOptionIndex": "Ajouter l'option {{index}}",
    "newOption": "Nouvelle option",
    "addOption": "Ajouter une option",
    "fieldValueIndex": "Valeur du champ {{index}}",
    "chooseOptions": "Choisir des options…",
    "chooseEntries": "Choisir des entrées…",
    "unsupportedMultiValueEditor": "Éditeur à valeurs multiples non pris en charge"
  },
  "graphExplorer": {
    "relationGraph": "Graphe des relations",
    "entry": "Entrée",
    "filterGraphByEntry": "Filtrer le graphe par entrée",
    "all": "Toutes",
    "status": "Statut",
    "graphRelationStatus": "Statut des relations du graphe",
    "proposedAndConfirmed": "Proposées et confirmées",
    "confirmed": "Confirmées",
    "proposed": "Proposées",
    "relation": "Relation",
    "searchRelationInTheGraph": "Rechercher une relation dans le graphe",
    "filterAtStoryTime": "Filtrer à un moment de l'histoire",
    "tick": "Tick",
    "graphTick": "Tick du graphe",
    "includeUnknownTime": "Inclure le temps inconnu",
    "enterANumericTickOrTurn": "Saisissez un tick numérique ou désactivez le filtre de temps.",
    "navigableRelationGraph": "Graphe de relations navigable",
    "selectName": "Sélectionner {{name}}",
    "entryCount_one": "{{count}} entrée",
    "entryCount_many": "{{count}} d'entrées",
    "entryCount_other": "{{count}} entrées",
    "relationCount_one": "{{count}} relation",
    "relationCount_many": "{{count}} de relations",
    "relationCount_other": "{{count}} relations",
    "hiddenBeyondViewLimit": "{{entries}} et {{relations}} au-delà de la limite d'affichage.",
    "relationsWithMissingEntries_one": "{{count}} relation avec des entrées manquantes.",
    "relationsWithMissingEntries_many": "{{count}} relations avec des entrées manquantes.",
    "relationsWithMissingEntries_other": "{{count}} relations avec des entrées manquantes.",
    "unknownDurationIncluded_one": "{{count}} relation de durée inconnue incluse dans le filtre.",
    "unknownDurationIncluded_many": "{{count}} relations de durée inconnue incluses dans le filtre.",
    "unknownDurationIncluded_other": "{{count}} relations de durée inconnue incluses dans le filtre.",
    "unknownDurationExcluded_one": "{{count}} relation de durée inconnue exclue du filtre.",
    "unknownDurationExcluded_many": "{{count}} relations de durée inconnue exclues du filtre.",
    "unknownDurationExcluded_other": "{{count}} relations de durée inconnue exclues du filtre."
  },
  "relationshipPanel": {
    "select": "Sélectionner…",
    "removedReference": "Référence supprimée :",
    "projectRelations": "Relations du projet",
    "relationsOf": "Relations de",
    "filterRelationsByEntry": "Filtrer les relations par entrée",
    "allEntries": "Toutes les entrées",
    "searchEntries": "Rechercher des entrées…",
    "searchRelations": "Rechercher des relations",
    "relationOrEntry": "Relation ou entrée",
    "newRelation": "Nouvelle relation",
    "editRelation": "Modifier la relation",
    "relationsLinkTwoEntries": "Les relations lient deux entrées",
    "addTwoEntriesInTheCodex": "Ajoutez au moins deux entrées dans le Codex, puis écrivez les mots qui les lient, comme « est le mentor de ».",
    "theWorldHasChangedTheFields": "Le monde a changé pendant que ceci était ouvert. Vos champs sont conservés ; rechargez pour enregistrer par rapport aux nouvelles données.",
    "reload": "Recharger",
    "anEntry": "Une entrée",
    "anotherEntry": "Une autre entrée",
    "relationSource": "Source de la relation",
    "relationType": "Type de relation",
    "isTheMentorOf": "est le mentor de",
    "relationTarget": "Cible de la relation",
    "direction": "Direction",
    "relationDirection": "Direction de la relation",
    "oneWay": "Sens unique",
    "bothWays": "Dans les deux sens",
    "when": "Quand",
    "relationTime": "Moment de la relation",
    "notSet": "Non défini",
    "betweenTwoMoments": "Entre deux moments",
    "fromAnEvent": "À partir d'un événement",
    "from": "De",
    "to": "à",
    "relationStart": "Début de la relation",
    "relationEnd": "Fin de la relation",
    "momentsHint": "Des moments de la chronologie du monde ; la fin n'est pas incluse.",
    "event": "Événement",
    "relationEvent": "Événement de la relation",
    "offset": "Décalage",
    "relationOffset": "Décalage de la relation",
    "offsetHint": "Des moments après l'événement ; négatif pour avant.",
    "status": "Statut",
    "relationStatus": "Statut de la relation",
    "proposed": "Proposée",
    "confirmed": "Confirmée",
    "rejected": "Rejetée",
    "superseded": "Remplacée",
    "confirmedRelationsCountAsCanonIn": "Les relations confirmées comptent comme canon dans les Vérifications.",
    "notes": "Notes",
    "relationNotes": "Notes de la relation",
    "howTheStoryShowsItAnd": "Comment l'histoire la montre, et ce qui reste ambigu.",
    "quotes": "Citations",
    "linkQuotes": "Lier des citations du texte",
    "quotesLinked": "Citations : {{count}}",
    "searchQuotations": "Rechercher des citations",
    "excerptOrNote": "Extrait ou note",
    "removedQuotation": "Citation supprimée :",
    "noQuotationYetAnnotateAPassage": "Aucune citation pour l'instant. Annotez un passage du manuscrit pour le citer ici.",
    "upTo100QuotationsShownUse": "Jusqu'à 100 citations affichées. Utilisez la recherche pour affiner la liste.",
    "saveRelation": "Enregistrer la relation",
    "cancel": "Annuler",
    "aDeletedEntry": "une entrée supprimée",
    "aDeletedEvent": "un événement supprimé",
    "timeBetween": "De {{start}} à {{end}}",
    "timeAtEvent": "À {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Aucune relation pour l'instant.",
    "noRelationMatches": "Aucune relation ne correspond.",
    "edit": "Modifier",
    "editCaption": "Modifier {{caption}}",
    "remove": "Supprimer",
    "removeCaption": "Supprimer {{caption}}",
    "removeThisRelationTheChangeStays": "Supprimer cette relation ? La modification reste dans l'historique.",
    "confirmRemoval": "Supprimer",
    "shownOfTotal": "100 relations affichées sur {{total}}. Affinez la recherche pour voir les autres.",
    "theWorldHasChangedReloadThe": "Le monde a changé. Rechargez la relation avant d'enregistrer.",
    "theRelationWasChangedOrRemoved": "La relation a été modifiée ou supprimée. Rechargez les données.",
    "explicitlyConfirmTheRelationBeforeSaving": "Choisissez de nouveau Confirmée pour faire de cette relation un canon.",
    "selectTwoEntriesThatExistIn": "Sélectionnez deux entrées qui existent dans le Codex.",
    "fillInTheTimeValuesOr": "Renseignez les moments, ou choisissez Non défini.",
    "enterAValidIntervalTheEnd": "La fin doit venir après le début.",
    "selectAnExistingEventAsThe": "Choisissez un événement qui existe encore.",
    "theSelectedQuotationIsNoLonger": "Une citation choisie n'existe plus.",
    "checkTheRelationTextAndThe": "Vérifiez les mots de la relation et les notes.",
    "theChangeWasNotSavedReload": "La modification n'a pas été enregistrée. Rechargez les données et réessayez."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Connectez-vous au compte lié et vérifiez votre accès au projet. Vos modifications locales sont conservées.",
    "syncTheManuscriptWithThisServer": "Synchronisez le manuscrit avec ce serveur avant de lier son Monde.",
    "theWorldChangedAfterTheComparison": "Le Monde a changé après la comparaison. Examinez de nouveau les copies actuelles.",
    "aConfirmationOrRestoredRecordNeeds": "Une confirmation ou un enregistrement restauré demande une vérification explicite avant de pouvoir se synchroniser.",
    "anAttachmentOrRemoteCopyFailed": "Une pièce jointe ou une copie distante a échoué à la vérification. Votre Monde local est conservé.",
    "theseChangesExceedASyncLimit": "Ces modifications dépassent une limite de synchronisation ou doivent être appliquées ensemble. Votre Monde local et les modifications en attente sont conservés.",
    "syncPausedYourLocalChangesAre": "Synchronisation suspendue. Vos modifications locales sont conservées.",
    "newMapNeedsPlan": "Les nouvelles cartes viennent avec Ink et Press. La carte reste sur cet appareil et le Monde attend : supprimez la nouvelle carte, ou choisissez une formule, pour le synchroniser à nouveau.",
    "worldSyncCouldNotFinishCheck": "La synchronisation du Monde n'a pas pu se terminer. Vérifiez la connexion et réessayez. Vos modifications locales sont conservées."
  },
  "vaultFolders": {
    "folderName": "Dossier {{name}}",
    "editFolder": "Modifier le dossier",
    "newSubfolder": "Nouveau sous-dossier",
    "moveContentsBeforeRemoving": "Déplacez le contenu avant de supprimer",
    "removeFolder": "Supprimer le dossier",
    "folderActionsName": "Actions du dossier {{name}}",
    "chooseThisFolderWhenEditingA": "Choisissez ce dossier en modifiant une page.",
    "projectFolders": "Dossiers du projet",
    "folders": "Dossiers",
    "newFolder": "Nouveau dossier",
    "groupPagesFromAnyCollection": "Regroupez des pages de n'importe quelle collection.",
    "foldersOrganizePagesWithoutChangingTheir": "Les dossiers organisent les pages sans changer leur collection ni leur contenu.",
    "cancel": "Annuler",
    "saveFolder": "Enregistrer le dossier",
    "name": "Nom",
    "folderName2": "Nom du dossier",
    "inside": "Dans",
    "parentFolder": "Dossier parent",
    "projectRoot": "Racine du projet",
    "removeEmptyFolder": "Supprimer le dossier vide ?",
    "removeNameFromTheProject": "Supprimer « {{name}} » du projet ?"
  },
  "vaultTable": {
    "unavailableEntry": "Entrée indisponible",
    "vaultTable": "Tableau du coffre",
    "pages": "Pages",
    "searchVaultTable": "Rechercher dans le tableau du coffre",
    "searchPages": "Rechercher des pages…",
    "tableCollection": "Collection du tableau",
    "allCollections": "Toutes les collections",
    "noCustomCollection": "Aucune collection personnalisée",
    "tableFolder": "Dossier du tableau",
    "allFolders": "Tous les dossiers",
    "unfiled": "Non classée",
    "scrollableVaultTable": "Tableau du coffre défilable",
    "name": "Nom",
    "collection": "Collection",
    "folder": "Dossier",
    "noPagesMatchTheseFilters": "Aucune page ne correspond à ces filtres.",
    "none": "Aucun",
    "yes": "Oui",
    "no": "Non",
    "pagesShown_one": "{{shown}} sur {{count}} page",
    "pagesShown_many": "{{shown}} sur {{count}} pages",
    "pagesShown_other": "{{shown}} sur {{count}} pages"
  },
  "vaultTree": {
    "blue": "Bleu",
    "emerald": "Émeraude",
    "gold": "Or",
    "violet": "Violet",
    "rose": "Rose",
    "amber": "Ambre",
    "teal": "Sarcelle",
    "slate": "Ardoise",
    "crimson": "Cramoisi",
    "bark": "Écorce",
    "forest": "Forêt",
    "navy": "Marine",
    "orchid": "Orchidée",
    "saffron": "Safran",
    "ink": "Encre",
    "ember": "Braise",
    "concept": "Concept",
    "character": "Personnage",
    "place": "Lieu",
    "faction": "Faction",
    "object": "Objet",
    "vault": "Coffre",
    "newCollection": "Nouvelle collection",
    "vaultView": "Vue du coffre",
    "pages": "Pages",
    "table": "Tableau",
    "pagesMarkedUnassignedKeepTheirPrevious": "Les pages marquées non attribuées gardent leurs champs précédents. Modifiez une page pour choisir sa collection.",
    "filterPages": "Filtrer les pages",
    "filterPages2": "Filtrer les pages…",
    "worldVault": "Coffre du Monde",
    "removeCollectionName": "Supprimer la collection {{name}}",
    "collectionSettingsForName": "Réglages de la collection {{name}}",
    "iconAndColour": "Icône et couleur",
    "newPageInName": "Nouvelle page dans {{name}}",
    "noPageYetAddTheFirst": "Aucune page pour l'instant — ajoutez la première avec +.",
    "nothingHereYet": "Rien ici pour l'instant.",
    "removeEmptyCollection": "Supprimer la collection vide ?",
    "removeNameAndItsSchema": "Supprimer « {{name}} » et son schéma ?",
    "removeCollection": "Supprimer la collection",
    "text": "Texte",
    "theSvgMustBeUnder16": "Le SVG doit faire moins de 16 Kio.",
    "thisFileIsNotAUsable": "Ce fichier n'est pas un SVG utilisable (les scripts et références externes sont retirés ; la racine doit être <svg>).",
    "collectionName": "Collection : {{name}}",
    "sharedFieldsApplyToEveryPage": "Les champs partagés s'appliquent à chaque page de cette collection. Chaque page peut aussi avoir ses propres champs.",
    "cancel": "Annuler",
    "saving": "Enregistrement…",
    "saveCollection": "Enregistrer la collection",
    "createCollection": "Créer la collection",
    "identity": "Identité",
    "nameAndIconAsTheTree": "Nom et icône, tels que l'arborescence et les pages les afficheront.",
    "name": "Nom",
    "collectionName2": "Nom de la collection",
    "magic": "Magie",
    "aCollectionWithThisNameAlready": "Une collection de ce nom existe déjà.",
    "icon": "Icône",
    "iconSource": "Source de l'icône",
    "lucide181": "Lucide (181)",
    "yourSvg": "Votre SVG",
    "collectionIcon": "Icône de la collection",
    "searchLucideIcons": "Rechercher des icônes Lucide",
    "searchIconsCastleSwordMoon": "Rechercher des icônes — château, épée, lune…",
    "loadingIcons": "Chargement des icônes…",
    "lucideIcon": "Icône Lucide",
    "noIconMatches": "Aucune icône ne correspond.",
    "chooseAnSvgFile": "Choisir un fichier SVG",
    "customSvgIcon": "Icône SVG personnalisée",
    "upTo16KibScriptsLinks": "Jusqu'à 16 Kio. Les scripts, liens et références externes sont retirés ; utilisez currentColor dans le fichier pour que la couleur de la collection s'applique.",
    "colour": "Couleur",
    "aPresetOneYouUsedRecently": "Une couleur prédéfinie, une utilisée récemment, ou la vôtre depuis la roue.",
    "collectionColour": "Couleur de la collection",
    "recent": "Récentes",
    "useHex": "Utiliser {{hex}}",
    "kindOfPage": "Type de page",
    "everyPageIsACodexEntry": "Chaque page est une entrée du Codex d'un seul type ; le type décide de la façon dont les Vérifications, les mentions @ et le graphe la traitent, et garde sa couleur partout.",
    "collectionBaseKind": "Type de base de la collection",
    "magicOrShipsConceptDeitiesOr": "Magie ou Navires → Concept · Divinités ou Maisons → Personnage ou Faction · une collection de villes → Lieu.",
    "sharedFields": "Champs partagés",
    "thePropertiesOfTheCollectionValues": "Les propriétés de la collection — les valeurs vivent sur chaque page, et une page peut toujours ajouter les siennes.",
    "collectionTemplate": "Modèle de collection",
    "template": "Modèle…",
    "addField": "Ajouter un champ",
    "exampleMagicLevelNumberRarityChoice": "Exemple : Magie → Niveau (nombre) · Rareté (choix : commun, rare, légendaire) · Obtenu (date de l'histoire) · Enseigné par (lien d'entrée).",
    "collectionFieldNameValue": "Nom du champ de collection {{value}}",
    "fieldName": "Nom du champ",
    "collectionFieldTypeValue": "Type du champ de collection {{value}}",
    "collectionFieldOptionsValue": "Options du champ de collection {{value}}",
    "optionsOnePerLine": "Options, une par ligne",
    "required": "Obligatoire",
    "requiredCollectionFieldValue": "Champ de collection obligatoire {{value}}",
    "removeCollectionFieldValue": "Supprimer le champ de collection {{value}}",
    "yesNo": "Oui / Non",
    "multipleChoice": "Choix multiple",
    "storyDate": "Date de l'histoire",
    "entryLink": "Lien d'entrée",
    "multipleEntryLinks": "Liens d'entrée multiples",
    "fieldParagraph": "Paragraphe",
    "fieldNumber": "Nombre",
    "fieldChoice": "Choix"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Versions cloud du Monde",
    "includesCodexPagesCollectionsFoldersFacts": "Comprend les pages du Codex, collections, dossiers, faits, relations et pièces jointes. Publiez ou téléchargez une version de façon explicite. Le manuscrit utilise la synchronisation des scènes.",
    "compareVersions": "Comparer les versions",
    "recoverPreviousWorld": "Récupérer le Monde précédent…",
    "deviceRevision": "Révision de l'appareil",
    "accountVersionRemoteversion": "Version du compte {{remoteVersion}}",
    "firstAccountVersion": "Première version du compte",
    "uploadDeviceVersion": "Envoyer la version de l'appareil…",
    "useAccountVersion": "Utiliser la version du compte…",
    "confirmTransfer": "Confirmer le transfert",
    "replaceWorldOnThisDeviceWith": "Remplacer le Monde de cet appareil par cette version ? Une copie du Monde et des pièces jointes actuels sera d'abord conservée. Le texte du manuscrit reste inchangé.",
    "saveThisCopyToYourAccount": "Enregistrer cette copie dans votre compte ? Les versions précédentes du compte seront conservées.",
    "restoreWorldFromBeforeTheLast": "Restaurer le Monde d'avant le dernier transfert ? Des modifications ultérieures empêchent cette restauration.",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "transferring": "Transfert en cours…",
    "codexPages": "Pages du Codex",
    "updateStoryideBeforePublishingChangesTo": "Mettez Musael à jour avant de publier des modifications dans ce Coffre.",
    "theAccountVersionChangedCompareAgain": "La version du compte a changé. Comparez de nouveau avant d'appliquer.",
    "worldChangedOnThisDeviceCompare": "Le Monde a changé sur cet appareil. Comparez de nouveau avant d'appliquer.",
    "accountVersionStorageIsFullPrevious": "Le stockage des versions du compte est plein. Les copies précédentes sont conservées.",
    "anAttachmentFailedItsIntegrityCheck": "Une pièce jointe a échoué à la vérification d'intégrité. Aucune copie locale n'a été remplacée.",
    "theAccountCopyFailedItsIntegrity": "La copie du compte a échoué à la vérification d'intégrité.",
    "noRecoveryCopyIsAvailableFor": "Aucune copie de récupération n'est disponible pour ce transfert.",
    "anIdentifierIsAlreadyUsedIn": "Un identifiant est déjà utilisé dans un autre projet.",
    "openOrSyncTheManuscriptWith": "Ouvrez ou synchronisez d'abord le manuscrit avec votre compte.",
    "yourAccountDoesNotHaveThe": "Votre compte n'a pas l'autorisation requise.",
    "signInAgainThisSessionWas": "Reconnectez-vous. Cette session a été révoquée.",
    "transferCancelled": "Transfert annulé.",
    "transferFailedCheckYourConnectionAnd": "Le transfert a échoué. Vérifiez votre connexion et comparez de nouveau.",
    "couldNotReadTheRecoveryCopy": "Impossible de lire la copie de récupération.",
    "mondoPrecedenteRipristinato": "Monde précédent restauré.",
    "accountVersionVersionSaved": "Version {{version}} du compte enregistrée.",
    "versionVersionAppliedToWorldOn": "Version {{version}} appliquée au Monde de cet appareil.",
    "cancellationRequested": "Annulation demandée.",
    "labelFacts": "Faits",
    "labelEvents": "Événements",
    "labelKnowledge": "Connaissances",
    "labelAnnotations": "Annotations",
    "labelRelationships": "Relations",
    "labelAttachments": "Pièces jointes",
    "labelCollections": "Collections",
    "labelFolders": "Dossiers",
    "changedCount_one": "{{count}} modifié",
    "changedCount_many": "{{count}} modifiés",
    "changedCount_other": "{{count}} modifiés"
  },
  "worldMaps": {
    "character": "Personnage",
    "place": "Lieu",
    "object": "Objet",
    "faction": "Faction",
    "concept": "Concept",
    "pinOf": "Épingle : {{name}}",
    "pinMissing": "Épingle d'une entrée manquante",
    "missingEntry": "Entrée manquante",
    "zoom": "Zoom",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrière",
    "fitToView": "Ajuster à la vue",
    "newMap": "Nouvelle carte",
    "newMapDescription": "Une image d'un lieu, pour y épingler les personnes, lieux et choses qui s'y trouvent.",
    "cancel": "Annuler",
    "saving": "Enregistrement…",
    "createMap": "Créer la carte",
    "mapOf": "Carte de",
    "aNewPlace": "Un nouveau lieu",
    "placeName": "Nom du lieu",
    "placeNamePlaceholder": "La Côte salée",
    "picture": "Image",
    "choosePicture": "Choisir un PNG, JPEG, WebP ou GIF",
    "pictureHint": "Jusqu'à 16 Mo. Elle devient l'une des pièces jointes de l'entrée.",
    "maps": "Cartes",
    "mapsLead": "Épinglez des entrées sur les images de vos lieux. Un lieu épinglé qui a sa propre carte l'ouvre.",
    "noMapsYet": "Aucune carte pour l'instant",
    "noMapsText": "Donnez une image à un lieu, puis épinglez-y les entrées qui lui appartiennent.",
    "addTheFirstMap": "Ajouter la première carte",
    "onePin": "1 épingle",
    "pins": "{{count}} épingles",
    "inPlace": "sur {{place}}",
    "chooseAnEntryOrName": "Choisissez une entrée ou écrivez un nom pour l'épingle.",
    "mapTrail": "Cartes au-dessus de celle-ci",
    "doneAdding": "Terminé",
    "addPin": "Ajouter une épingle",
    "labels": "Étiquettes",
    "replacePicture": "Remplacer l'image",
    "removeMap": "Supprimer la carte",
    "hintClick": "Cliquez sur la carte à l'endroit de l'épingle.",
    "hintChoose": "Choisissez ce que l'épingle désigne, à droite.",
    "pictureMissing": "L'image de cette carte n'est pas encore sur cet appareil.",
    "pinDetails": "Détails de l'épingle",
    "newPin": "Nouvelle épingle",
    "entry": "Entrée",
    "chooseAnEntry": "Choisir une entrée",
    "noEntryLabelOnly": "Aucune entrée, juste une étiquette",
    "labelOnTheMap": "Étiquette sur la carte",
    "labelDefault": "Le nom de l'entrée",
    "labelRequired": "Nécessaire sans entrée",
    "placePin": "Placer l'épingle",
    "label": "Étiquette",
    "openEntry": "Ouvrir l'entrée",
    "openItsMap": "Ouvrir sa carte",
    "position": "{{x}} % en largeur, {{y}} % en hauteur",
    "removePin": "Supprimer l'épingle",
    "noPinsYet": "Aucune épingle pour l'instant. Utilisez Ajouter une épingle, puis cliquez sur la carte.",
    "shownOn": "Affichée sur",
    "openEntryOf": "Ouvrir {{name}}",
    "removeMapTitle": "Supprimer la carte de {{name}} ?",
    "removeMapMessage": "Les épingles partent avec elle. L'image reste dans les pièces jointes de l'entrée."
  },
  "worldPanel": {
    "checks": "Vérifications",
    "findAndFixConsistencyIssuesIn": "Les faits, événements et relations de votre monde comparés au manuscrit. Sans IA.",
    "running": "Exécution…",
    "runChecks": "Lancer les vérifications",
    "lastRunAt": "Dernière exécution à {{time}}",
    "oneAtATime": "Un seul à la fois",
    "exclusiveRelation": "Relation exclusive",
    "noRelationIsExclusive": "Aucune relation n'est exclusive",
    "exclusivityType": "Type d'exclusivité",
    "oneSourcePerTarget": "Une source pour chaque cible",
    "oneTargetPerSource": "Une cible pour chaque source",
    "oneAtATimeHint": "Une relation qui ne peut valoir que pour un seul à la fois, comme « possède » : deux propriétaires de la même chose aux mêmes moments deviennent un conflit.",
    "rulesNeedRelations": "Les règles utilisent vos relations. Ajoutez-en une dans Connexions, comme « possède », puis rendez-la exclusive ici.",
    "results": "Résultats",
    "whatTheChecksLookFor": "Ce que cherchent les vérifications",
    "twoHoldersAtOnce": "Deux détenteurs à la fois",
    "eventsOutOfOrder": "Événements dans le désordre",
    "quotedPastItsLimit": "Cité au-delà de sa limite",
    "linksToDeletedEntries": "Liens vers des entrées supprimées",
    "notesThatLostTheirPlace": "Notes qui ont perdu leur place",
    "relationsOverTime": "Relations dans le temps",
    "scopeOwnership": "Une chose détenue par deux entrées aux mêmes moments, d'après les faits confirmés.",
    "scopeFlashback": "Un événement lu après un autre qui survient plus tard dans le monde : un retour en arrière, ou une erreur.",
    "scopeReveal": "Un fait cité dans une scène après la dernière que vous aviez autorisée pour lui.",
    "scopeOrphans": "Des notes et des faits qui renvoient à une entrée ou à une fiche de la Bibliothèque qui n'existe plus.",
    "scopeAnchors": "Un passage cité dont les mots ont bougé ou changé dans sa scène.",
    "scopeRelations": "Les relations confrontées à la règle ci-dessus et aux citations qu'elles invoquent.",
    "filterResults": "Filtrer les résultats",
    "all": "Tous",
    "conflicts": "Conflits",
    "warnings": "Avertissements",
    "needsData": "Données manquantes",
    "noIssuesFound": "Aucun problème trouvé",
    "theExecutedRulesFoundNoViolation": "Rien ne contredit les faits et règles que vous avez posés. Les vérifications ne connaissent que ce que vous avez consigné.",
    "notEnoughData": "Pas assez de données",
    "quotesInTheText": "Citations dans le texte",
    "anchorInPlace": "En place",
    "anchorMoved": "Déplacée",
    "anchorGone": "Disparue",
    "reAnchor": "Réancrer",
    "openScene": "Ouvrir la scène",
    "checkedAt": "Vérifié à {{time}}.",
    "twoHold": "{{a}} et {{b}} détiennent tous deux « {{object}} » en même temps.",
    "heldTwice": "{{a}} détient « {{object}} » deux fois aux mêmes moments.",
    "flashbackSentence": "« {{earlier}} » a lieu avant « {{later}} » dans le monde mais est lu après : un retour en arrière, sauf si vous n'en vouliez pas.",
    "revealSentence": "« {{fact}} » est cité dans {{scene}}, après la dernière scène que vous aviez autorisée pour lui.",
    "allowedUpToScene": "Autorisé jusqu'à la scène {{scene}}",
    "orphanFactSentence": "Un fait (« {{fact}} ») concerne une entrée supprimée.",
    "orphanNoteSentence": "La note sur « {{excerpt}} » renvoie à une entrée supprimée.",
    "orphanConceptSentence": "La note sur « {{excerpt}} » renvoie à une fiche de la Bibliothèque qui n'existe plus.",
    "movedSentence": "« {{excerpt}} » a bougé dans {{scene}} : réancrez la note pour qu'elle le suive.",
    "eventWithoutTime": "« {{title}} » n'a pas de date dans le monde, son ordre ne peut donc pas être vérifié.",
    "factWithoutTime": "« {{fact}} » n'a pas de période, son détenteur ne peut donc pas être vérifié.",
    "recordWithoutTime": "Un enregistrement n'a pas de date, il ne peut donc pas être vérifié.",
    "aDeletedEntry": "une entrée supprimée",
    "aDeletedEvent": "un événement supprimé",
    "aScene": "une scène",
    "fromTo": "De {{start}} à {{end}}",
    "relativeToAnEvent": "Relative à un événement",
    "timeNotSet": "Non défini",
    "facts": "Faits",
    "factsLead": "Ce que vous affirmez sur chaque entrée. Les vérifications lisent ceux que vous confirmez et les comparent au manuscrit.",
    "entries": "Entrées",
    "addAnEntry": "Ajouter une entrée",
    "addTheFirstEntry": "Ajouter la première entrée",
    "newEntityName": "Nom de la nouvelle entité",
    "entityType": "Type d'entité",
    "addEntity": "Ajouter l'entité",
    "character": "Personnage",
    "place": "Lieu",
    "object": "Objet",
    "faction": "Faction",
    "other": "Autre",
    "deleteEntityReferencesBecomeOrphaned": "Supprimer l'entité (les références deviennent orphelines)",
    "deleteEntityName": "Supprimer l'entité {{name}}",
    "noFactYet": "Aucun fait sur {{name}} pour l'instant. Un nouveau fait commence comme proposé ; confirmez-le pour qu'il compte.",
    "proposed": "Proposé",
    "confirmed": "Confirmé",
    "rejected": "Rejeté",
    "superseded": "Remplacé",
    "worldFact": "Fait du monde",
    "characterBelief": "Croyance",
    "testimony": "Témoignage",
    "authorHypothesis": "Hypothèse",
    "confirm": "Confirmer",
    "confirmExplicitApproval": "Confirmer (approbation explicite)",
    "newFactAbout": "Nouveau fait sur {{name}}",
    "predicatePlaceholder": "possède",
    "predicate": "Prédicat",
    "valuePlaceholder": "l'épée",
    "value": "Valeur",
    "kind": "Type",
    "epistemicKind": "Type épistémique",
    "kindHint": "Seuls les faits du monde comptent comme vérité ; croyances, témoignages et hypothèses sont conservés mais pas vérifiés comme canon.",
    "when": "Quand",
    "timeKind": "Type de temps",
    "betweenTwoMoments": "Entre deux moments",
    "from": "De",
    "to": "à",
    "startTick": "Tick de début",
    "endTick": "Tick de fin",
    "momentsHint": "Des moments de la chronologie du monde ; la fin n'est pas incluse.",
    "reveal": "Révélation",
    "maximumRevealNarrativeIndex": "Révélation maximale (indice narratif)",
    "noLimit": "Sans limite",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Les citations de ce fait dans une scène ultérieure sont signalées.",
    "addFactProposed": "Ajouter comme proposé",
    "selectAnEntityToSeeAnd": "Choisissez une entrée pour voir et ajouter ses faits.",
    "noEntityYet": "Aucune entrée pour l'instant. Ajoutez un personnage, un lieu ou un objet ci-dessus, ou dans le Codex.",
    "resultDetails": "Détails du résultat",
    "conflict": "Conflit",
    "warning": "Avertissement",
    "whatWasCompared": "Ce qui a été comparé",
    "whatToDo": "Que faire",
    "comparedOwnership": "Les faits du monde confirmés ayant une période. Deux détenteurs de la même chose ne peuvent pas se chevaucher.",
    "comparedFlashback": "La date de chaque événement dans le monde face à l'ordre de sa scène dans le livre.",
    "comparedReveal": "La dernière scène autorisée pour un fait face aux scènes qui le citent.",
    "comparedOrphans": "Chaque note et chaque fait face aux entrées et fiches de la Bibliothèque qui existent.",
    "comparedAnchors": "La citation de chaque note face au texte actuel de la scène.",
    "confirmOnlyOneOwnerInThe": "Gardez un seul détenteur pour ces moments : réduisez l'une des périodes, ou remettez l'un des faits à proposé.",
    "ifTheSceneIsADeliberate": "Si la scène est un retour en arrière voulu, gardez-la. Sinon, déplacez la scène ou changez la date de l'événement.",
    "raiseTheMaximumRevealSceneOf": "Autorisez une scène plus tardive pour le fait, ou déplacez la citation plus tôt.",
    "restoreTheMissingEntityFromThe": "Restaurez l'entrée depuis l'historique du Codex, ou supprimez la note ou le fait qui y renvoie.",
    "useReAnchorManualOnThe": "Utilisez Réancrer sur la citation dans les résultats, ou ouvrez la scène et sélectionnez de nouveau le passage.",
    "giveTheEventOrFactAn": "Donnez-lui une date dans le monde, ou laissez-le sans : la vérification reste muette plutôt que de deviner.",
    "selectAResult": "Sélectionnez un résultat",
    "detailsConstraintsAndSuggestedFixesAppear": "Ce qui a été comparé, et que faire, apparaissent ici.",
    "thisAnnotationCannotBeReAnchored": "Cette note ne peut pas être réancrée : « {{excerpt}} » est absent ou apparaît plusieurs fois dans la scène.",
    "revisionTools": "Outils de révision",
    "loadingRevisionTools": "Chargement des outils de révision…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "Le contenu a changé pendant sa confirmation. Choisissez le contenu et l'approbation que vous avez examinés.",
    "theseChangesCannotBeCombinedInto": "Ces modifications ne peuvent pas être combinées en un Monde valide. Choisissez la version complète à garder ; les deux copies restent en récupération.",
    "thisDevice": "Cet appareil",
    "yourAccount": "Votre compte",
    "viewWorld": "Voir le Monde",
    "previousSharedValue": "Valeur partagée précédente",
    "theActionCouldNotFinishYour": "L'action n'a pas pu se terminer. Vos modifications locales sont conservées.",
    "worldSync": "Synchronisation du Monde",
    "syncCodexPagesFactsTimelinesCollections": "Synchronisez entre appareils les pages du Codex, faits, chronologies, collections et pièces jointes. Les notes et croquis se synchronisent séparément, plus bas.",
    "syncWorldAutomatically": "Synchroniser le Monde automatiquement",
    "n1PendingChange": "1 modification en attente",
    "pendingPendingChanges": "{{pending}} modifications en attente",
    "syncNow": "Synchroniser maintenant",
    "exportRecoveryCopies": "Exporter les copies de récupération",
    "compareBeforeSyncing": "Comparer avant de synchroniser",
    "signInToTheLinkedAccount": "Connectez-vous au compte lié pour synchroniser. Les modifications locales restent enregistrées.",
    "signInToCompareYourWorld": "Connectez-vous pour comparer votre Monde et activer la synchronisation.",
    "chooseYourStartingWorld": "Choisissez votre Monde de départ",
    "bothCopiesHaveTheSameContent": "Les deux copies ont le même contenu.",
    "keepTheWorldOnThisDevice": "Gardez le Monde de cet appareil, ou utilisez la copie de votre compte. Le Monde local précédent et ses pièces jointes sont conservés en récupération.",
    "keepThisDeviceSync": "Garder cet appareil et synchroniser",
    "useAccountCopySync": "Utiliser la copie du compte et synchroniser",
    "cancel": "Annuler",
    "reviewConcurrentChanges": "Examiner les modifications simultanées",
    "chooseEachValueToKeepOther": "Choisissez chaque valeur à garder. Les autres modifications fusionnent automatiquement. Les deux versions restent récupérables.",
    "applyReviewedChoices": "Appliquer les choix examinés",
    "syncingWorldAndAttachments": "Synchronisation du Monde et des pièces jointes…",
    "codexPages": "Pages du Codex",
    "onThisDevice": "Sur cet appareil",
    "waitingToSync": "En attente de synchronisation",
    "syncing": "Synchronisation…",
    "upToDate": "À jour",
    "reviewNeeded": "Examen nécessaire",
    "emptyText": "(texte vide)",
    "emptyList": "(liste vide)",
    "worldStructure": "Structure du Monde",
    "labelFacts": "Faits",
    "labelEvents": "Événements",
    "labelKnowledge": "Connaissances",
    "labelAnnotations": "Annotations",
    "labelRelationships": "Relations",
    "labelAttachments": "Pièces jointes",
    "labelCollections": "Collections",
    "labelFolders": "Dossiers",
    "paused": "En pause",
    "addedCount_one": "{{count}} ajouté",
    "addedCount_many": "{{count}} ajoutés",
    "addedCount_other": "{{count}} ajoutés",
    "removedCount_one": "{{count}} supprimé",
    "removedCount_many": "{{count}} supprimés",
    "removedCount_other": "{{count}} supprimés",
    "changedCount_one": "{{count}} modifié",
    "changedCount_many": "{{count}} modifiés",
    "changedCount_other": "{{count}} modifiés",
    "removedValue": "Supprimé",
    "emptyValue": "Vide"
  },
  "worldReviewTools": {
    "deletedEntry": "Entrée supprimée",
    "timeUnknown": "Date inconnue",
    "storyTimeInterval": "Intervalle du temps de l'histoire",
    "relativeToEventPreserved": "Relative à l'événement (conservée)",
    "from": "De",
    "until": "Jusqu'à",
    "characterKnowledge": "Connaissances des personnages",
    "couldNotCheckTheSavedManuscriptRetry": "Impossible de vérifier le manuscrit enregistré. Réessayez.",
    "revisionTools": "Outils de révision",
    "changeImpact": "Impact d'une modification",
    "whatPointsToThisRecord": "Qu'est-ce qui renvoie à cet enregistrement ?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Liens explicites uniquement, y compris les liens indirects. Modifier un enregistrement ne réécrit pas ce qui en dépend.",
    "impactRecord": "Enregistrement concerné",
    "chooseARecord": "Choisir un enregistrement",
    "linkedRecordsWorldRevision": "enregistrements liés · révision du Monde",
    "directLink": "Lien direct",
    "missingSourceScene": "Scène source manquante",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Aucun lien d'enregistrement explicite vers cette entrée. La prose non liée est hors de cette vérification.",
    "whenDidTheyLearnIt": "Quand l'ont-ils appris ?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Consignez l'acquisition et l'usage sur le même axe du temps de l'histoire. Les suppositions et croyances restent à part ; l'ordre des chapitres n'est jamais traité comme le temps de l'histoire.",
    "recordKnowledge": "Consigner une connaissance",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "Impossible d'enregistrer. Vérifiez les intervalles, ou annulez et rouvrez si le Monde a changé.",
    "character": "Personnage",
    "knowledgeCharacter": "Personnage concerné",
    "chooseACharacter": "Choisir un personnage",
    "fact": "Fait",
    "knowledgeFact": "Fait connu",
    "chooseAConfirmedWorldFact": "Choisir un fait du monde confirmé",
    "acquired": "Acquis",
    "acquisitionSource": "Source de l'acquisition",
    "noSourceAttached": "Aucune source jointe",
    "use": "Usage",
    "scene": "Scène",
    "chooseAScene": "Choisir une scène",
    "knownInformation": "Information connue",
    "belief": "Croyance",
    "guess": "Supposition",
    "passageSource": "Source du passage",
    "noPassageAttached": "Aucun passage joint",
    "removeUse": "Retirer l'usage",
    "addUse": "Ajouter un usage",
    "confirmAndSave": "Confirmer et enregistrer",
    "cancel": "Annuler",
    "missingFact": "Fait manquant",
    "atUnknownRelativeTime": "à une date inconnue ou relative",
    "edit": "Modifier",
    "couldNotRemoveTheRecordRefreshAndRetry": "Impossible de supprimer l'enregistrement. Actualisez et réessayez.",
    "checkSavedKnowledge": "Vérifier les connaissances enregistrées",
    "theWorldChangedSinceThisResultRunTheCheck": "Le Monde a changé depuis ce résultat. Relancez la vérification.",
    "recordedUseIsEarlierThanAcquisition": "L'usage consigné précède l'acquisition",
    "recordedTimesAreInOrder": "Les dates consignées sont dans l'ordre",
    "beliefOrGuessNotAKnowledgeConflict": "Croyance ou supposition — pas un conflit de connaissance",
    "notEnoughInformationToCompare": "Pas assez d'informations pour comparer",
    "attachedPassagesMatchTheSavedText": "Les passages joints correspondent au texte enregistré",
    "aSourceIsMissingStaleOrBelongsToAnother": "Une source est manquante, périmée ou appartient à une autre scène",
    "authorRecordedTimesPassagesAreNotVerified": "Dates consignées par l'auteur ; les passages ne sont pas vérifiés",
    "openScene": "Ouvrir la scène",
    "noConfirmedKnowledgeUsesToCompare": "Aucun usage de connaissance confirmé à comparer.",
    "openNamedScene": "Ouvrir {{title}}",
    "recordSummary": "Usages : {{count}} · {{lifecycle}} · Acquis {{time}}",
    "checkSummary": "Vérifié à {{time}} · {{count}} usages consignés. Actualisez après avoir modifié la prose.",
    "resultsLimitedTo500Records": "Résultats limités à 500 enregistrements",
    "linksAway": "à {{depth}} liens de distance",
    "useNKind": "Utiliser {{n}} type",
    "useN": "Utiliser {{n}}",
    "useNSource": "Utiliser {{n}} source",
    "checking": "Vérification…"
  },
  "worldSection": {
    "overview": "Vue d'ensemble",
    "vault": "Coffre",
    "timeline": "Chronologie",
    "connections": "Connexions",
    "references": "Références",
    "checks": "Vérifications",
    "analysis": "Analyse",
    "characters": "Personnages",
    "locations": "Lieux",
    "factions": "Factions",
    "objects": "Objets",
    "concepts": "Concepts",
    "worldViews": "Vues du monde",
    "world": "Monde",
    "browseByType": "Parcourir par type",
    "filterByType": "Filtrer par type",
    "all": "Tous",
    "newEntry": "Nouvelle entrée",
    "cercaNelCodex": "Rechercher dans le Codex",
    "searchEntries": "Rechercher des entrées…",
    "entry": "entrée",
    "entries": "entrées",
    "alsoAliases": "Aussi : {{aliases}}",
    "noEntriesYetCreateTheFirst": "Aucune entrée pour l'instant. Créez le premier personnage, lieu ou faction.",
    "noEntryMatches": "Aucune entrée ne correspond.",
    "editName": "Modifier {{name}}",
    "edit": "Modifier",
    "archive": "Archiver",
    "confirmArchive": "Confirmer l'archivage",
    "notesAndSketches": "Notes et croquis",
    "alsoKnownAs": "Aussi connu sous le nom de",
    "addADescriptionOneLineThat": "Ajoutez une description — une ligne qui dit ce que c'est.",
    "none": "Aucun",
    "yes": "Oui",
    "no": "Non",
    "removedEntry": "Entrée supprimée",
    "unavailableEntry": "Entrée indisponible",
    "noNotesYetEditTheEntry": "Pas encore de notes. Modifiez l'entrée pour la décrire.",
    "linkedScenes": "Scènes liées",
    "showTheEntriesOfABook": "Afficher les entrées d'un livre",
    "allBooks": "Tous les livres",
    "bookLine": "Livre {{number}} · {{title}}",
    "inNoBookYet": "Dans aucun livre pour l'instant",
    "scenesThatMentionThisEntryBy": "Les scènes qui mentionnent cette entrée par son nom ou un alias apparaissent ici.",
    "facts": "Faits",
    "noFactRecordedFactsAreAdded": "Aucun fait consigné. Les faits s'ajoutent et s'approuvent dans les Vérifications.",
    "relations": "Relations",
    "noRelationYet": "Aucune relation pour l'instant.",
    "proposed": " · proposée",
    "viewAll": "Tout voir",
    "attachments": "Pièces jointes",
    "attachAnImageToUseIt": "Joignez une image pour l'utiliser comme portrait.",
    "kib": "Kio",
    "open": "Ouvrir",
    "remove": "Retirer",
    "addAttachment": "Ajouter une pièce jointe",
    "stateAtStoryTime": "État à un moment de l'histoire",
    "tick": "Tick",
    "factsWithoutACompleteInterval": "faits sans intervalle complet.",
    "selectAnEntry": "Sélectionnez une entrée",
    "charactersPlacesFactionsAndObjectsLive": "Les personnages, lieux, factions et objets vivent ici, avec leurs faits, relations et pièces jointes.",
    "recentChanges": "Modifications récentes",
    "undoChange": "Annuler la modification",
    "worldTimeline": "Chronologie du Monde",
    "eventsPeopleAndPlacesInA": "Événements, personnes et lieux dans un contexte plus large.",
    "noEventYet": "Aucun événement pour l'instant",
    "addTheFirstEventWithA": "Ajoutez le premier événement avec une date dans l'histoire, ou laissez la date inconnue jusqu'à ce que vous la connaissiez.",
    "tick2": "tick",
    "plotEvent": "Événement d'intrigue",
    "worldEvent": "Événement du monde",
    "openScene": "Ouvrir la scène",
    "unknownTime": "Date inconnue",
    "unknown": "inconnue",
    "seeHowYourWorldSPeople": "Voyez comment les personnes, lieux et idées de votre monde sont reliés.",
    "connectionsView": "Vue des connexions",
    "graph": "Graphe",
    "list": "Liste",
    "nothingToConnectYet": "Rien à relier pour l'instant",
    "createEntriesInTheCodexAnd": "Créez des entrées dans le Codex et reliez-les dans la vue Liste.",
    "selectedEntry": "Entrée sélectionnée",
    "relationSummary": "Résumé des relations",
    "noSceneMentionsThisEntryYet": "Aucune scène ne mentionne encore cette entrée.",
    "openInCodex": "Ouvrir dans le Codex",
    "selectANodeToSeeIts": "Sélectionnez un nœud pour voir ses relations et ses scènes.",
    "annotationsAnchoredInTheManuscriptAnd": "Les annotations ancrées dans le manuscrit et les fichiers que vous gardez pour votre monde.",
    "addFile": "Ajouter un fichier",
    "annotations": "Annotations",
    "selectTextInTheManuscriptAnd": "Sélectionnez du texte dans le manuscrit et utilisez « Annoter » pour ancrer un procédé, une entité ou une note.",
    "scene": "Scène",
    "device": "Procédé",
    "entity": "Entité",
    "note": "Note",
    "imagesPdfsNotesAndAudioYou": "Images, PDF, notes et audio que vous joignez au monde ou à une entrée.",
    "linked": "Lié",
    "orphan": "Orphelin",
    "openFile": "Ouvrir le fichier",
    "referenceDetails": "Détails de la référence",
    "textAnnotation": "Annotation de texte",
    "kind": "Type",
    "anchor": "Ancre",
    "concept": "Concept",
    "created": "Créée",
    "anchorStatesValidStaleOrphanedAnd": "Les états d'ancre (valide, périmée, orpheline) et le réancrage sont calculés dans les Vérifications.",
    "attachment": "Pièce jointe",
    "type": "Type",
    "size": "Taille",
    "linkedTo": "Lié à",
    "added": "Ajouté",
    "confirmRemove": "Confirmer le retrait",
    "selectAnAnnotationOrAFile": "Sélectionnez une annotation ou un fichier.",
    "exploreTheShapeOfYourStory": "Explorez la forme de votre histoire : longueur, présence et densité d'une scène à l'autre.",
    "sceneLength": "Longueur des scènes",
    "wordsPerScene": "Mots par scène",
    "noScenesYet": "Aucune scène pour l'instant.",
    "titleFmtWords": "{{title}} : {{fmt}} mots",
    "entityDensity": "Densité d'entités",
    "codexMentionsPerScene": "Mentions du Codex par scène",
    "titleMentionsMentions": "{{title}} : {{mentions}} mentions",
    "characterAppearanceMap": "Carte des apparitions des personnages",
    "aDotWhereACharacterIs": "Un point là où un personnage est nommé dans une scène",
    "addCharactersToTheCodexAnd": "Ajoutez des personnages au Codex et nommez-les dans les scènes.",
    "thisScene": "Cette scène",
    "words": "Mots",
    "paragraphs": "Paragraphes",
    "sentencesEst": "Phrases (est.)",
    "distinctWords": "Mots distincts",
    "annotatedDevices": "Procédés annotés",
    "n1000Words": "/ 1 000 mots",
    "repetitions": "Répétitions",
    "exportHtml": "Exporter en HTML",
    "exportTxt": "Exporter en TXT",
    "events": "Événements",
    "confirmedFacts": "Faits confirmés",
    "recentlyChanged": "Modifié récemment",
    "changesToTheWorldWillBe": "Les modifications du monde seront listées ici, chacune avec un bouton d'annulation.",
    "undo": "Annuler",
    "startHere": "Commencez ici",
    "overviewEmptyLead": "Les personnages, lieux et événements de votre histoire, reliés aux scènes où ils apparaissent.",
    "addACharacter": "Ajouter un personnage",
    "addACharacterText": "Qui est la personne, ce qu'elle veut et ce qui lui barre la route.",
    "addAPlace": "Ajouter un lieu",
    "addAPlaceText": "Là où se passent les scènes : une ville, un navire, une simple pièce.",
    "addAnEventText": "Quelque chose qui arrive dans l'histoire, avec sa date ou sans.",
    "inThisWorld": "Dans ce monde",
    "createAnEntry": "Créer une entrée",
    "aCharacterAPlaceAFaction": "Un personnage, un lieu, une faction, un objet ou un concept.",
    "addAnEvent": "Ajouter un événement",
    "withAnExactStoryTimeOr": "Avec une date exacte dans l'histoire ou une date inconnue.",
    "runTheChecks": "Lancer les vérifications",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Détenteurs, ordre, révélations et relations dans le temps, comparés au texte.",
    "loadingTheWorld": "Chargement du monde…",
    "maps": "Cartes",
    "openItsMap": "Ouvrir sa carte",
    "addAMap": "Ajouter une carte",
    "pinnedOn": "Épinglée sur",
    "typeCharacter": "Personnage",
    "typeLocation": "Lieu",
    "typeObject": "Objet",
    "typeFaction": "Faction",
    "typeConcept": "Concept",
    "annotationsToReAnchor_one": "{{count}} annotation à réancrer.",
    "annotationsToReAnchor_many": "{{count}} d'annotations à réancrer.",
    "annotationsToReAnchor_other": "{{count}} annotations à réancrer."
  }
}
